import { ExcelService } from './../../../services/excel.service';
import { AuthService } from './../../../services/auth.service';
import { NgxRolesService } from 'ngx-permissions';
import { School } from './../../../models/school';
import { Observable } from 'rxjs/Observable';
import { DataTablesResponse } from './../../../models/DataTablesResponse';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { PassengerManualNotif } from './../../../models/passenger-manual-notif';
import { Component, OnInit, OnDestroy, ViewChild, NgZone } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Select2OptionData } from 'ng2-select2';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { PNotifyService } from '../../../services/pnotify.service';

@Component({
  selector: 'app-passenger-manual-notif-datatable',
  templateUrl: './passenger-manual-notif-datatable.component.html',
  styleUrls: ['./passenger-manual-notif-datatable.component.css']
})
export class PassengerManualNotifDatatableComponent implements OnInit, OnDestroy {

  filter = {
    clientId: '',
    schoolId: '',
    busId: '',
    date: ''
  };
  staticFilter: any;

  clients: any[];
  schools: any[];
  buses: any[];
  passengers: any[];
  public schoolsData: Array<Select2OptionData>;
  public busesData: Array<Select2OptionData>;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  // ----- Start Option Scrollbar -----------
  isScrollbar: true;
  scrollbarOptions = {
    axis: 'y',
    theme: 'minimal-dark'
  };
  // ----- End Option Scrollbar -----------

  selectedAll = false;
  selectedMulti = false;
  pnotify = undefined;
  dtOptions: any = {};
  passengerManualNotifs: any[];
  isResponsible = false;
  // ----- Start DatePicker -----------
  dateTimeFilter = (d: Date): boolean => {
    return true;
  }
  // ----- End DatePicker -----------

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private roleService: NgxRolesService,
    private excelService: ExcelService,
    private router: Router,
    private zone: NgZone,
    pnotifyService: PNotifyService
  ) {

    if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
      this.isResponsible = true;
      const client = this.authService.getUser().School.Client;
      this.filter.clientId = client.id;
    } else {
      const client = this.authService.getUser();
      this.filter.clientId = client.id;
    }
    this.initSchoolSelect();
    this.pnotify = pnotifyService.getPNotify();
  }

  ngOnInit(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (this.staticFilter.date) {
      this.staticFilter.date = moment(this.staticFilter.date).format('YYYY-MM-DD');
    }
    this.dtOptions = {
      searching: false,
      pageLength: 5,
      serverSide: true,
      processing: true,
      lengthMenu: [[5, 10, 25, 50, 100], [5, 10, 25, 50, 100]],
      order: [[1, 'asc']],
      ordering: false,
      columnDefs: [
        { 'orderable': false, 'targets': 0 }
      ],
      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.filter = this.staticFilter;
        this.http.post<DataTablesResponse>(
          '/api/passengerManualNotif',
          dataTablesParameters,
          {}
        ).subscribe((resp: any) => {
          this.passengerManualNotifs = resp.data;
          const dta = [];
          this.passengerManualNotifs.forEach(passengerManualNotif => {
            dta.push({
              id: passengerManualNotif.id,
              checkbox: `<label class="el-switch" style="font-size:80%">
                          <input  type="checkbox"
                                  name="checkboxs[]"
                                  value="${passengerManualNotif.id}"
                                  ${this.selectedAll ? 'checked' : ''}
                          >
                          <span class="el-switch-style"></span>
                        </label>`,
              schoolName: passengerManualNotif.schoolName,
              busName: passengerManualNotif.Bus.name,
              date: moment(passengerManualNotif.date).format('DD/MM/YYYY'),
              type: passengerManualNotif.type,
              subject: passengerManualNotif.subject,
              message: `<span class="truncate-ellipsis">${passengerManualNotif.message}</span>`,
              //isSent: (passengerManualNotif.isSent ? 'Oui' : 'Non'),
              actions: `
                <a class="btn btnAction btnNavigate" data-url="/passengerManualNotif/view/${passengerManualNotif.id}">
                  <i class="fa fa-search fa-2x" aria-hidden="true"></i>Détail
                </a>
                <button class="btn btnAction btnDelete" data-passenger-manual-notif-id="${passengerManualNotif.id}">
                  <i class="fa fa-trash fa-2x" aria-hidden="true"></i>Supprimer
                </button>
              `
            });
          });
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: dta
          });
        });
      },
      fnCreatedRow: function (nRow, aData, iDataIndex) {
        $(nRow).attr('id', 'passengerManualNotif_' + aData.id);
      },
      columns: [
        { data: 'checkbox' },
        { data: 'schoolName' },
        { data: 'busName' },
        { data: 'date' },
        { data: 'type' },
        { data: 'subject' },
        { data: 'message' },
        { data: 'actions' },
      ],
      dom: '<t> <"row" <"col-md-4"l><"col-md-8"p>>',
      language: {
        'sProcessing': 'Traitement en cours...',
        'sSearch': 'Rechercher&nbsp;:',
        'sLengthMenu': 'Afficher _MENU_ &eacute;l&eacute;ments',
        'sInfo': 'Affichage de l\'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments',
        'sInfoEmpty': 'Affichage de l\'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment',
        'sInfoFiltered': '(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)',
        'sInfoPostFix': '',
        'sLoadingRecords': 'Chargement en cours...',
        'sZeroRecords': 'Aucun &eacute;l&eacute;ment &agrave; afficher',
        'sEmptyTable': 'Aucune donn&eacute;e disponible dans le tableau',
        'oPaginate': {
          'sFirst': 'Premier',
          'sPrevious': 'Pr&eacute;c&eacute;dent',
          'sNext': 'Suivant',
          'sLast': 'Dernier'
        },
        'oAria': {
          'sSortAscending': ': activer pour trier la colonne par ordre croissant',
          'sSortDescending': ': activer pour trier la colonne par ordre d&eacute;croissant'
        }
      },
      // Use this attribute to enable the responsive extension
      responsive: true
    };
    $('table').on('click', '.btnDelete', (event) => {
      this.onDelete($(event.currentTarget).data('passengerManualNotifId'));
    });
    $('table').on('click', '.btnNavigate', (event) => {
      this.onNavigate($(event.currentTarget).data('url'));
    });
    $('table').on('change', '[name="checkboxs[]"]', (event) => this.onCheckChange());
    $('table').on('draw.dt', (event) => this.onCheckChange());

  }

  initSchoolSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId
      }
    });
    this.http.get(
      '/api/school/lookup',
      { params }
    ).subscribe((schools: any[]) => {
      this.schools = schools;
      const array1 = [{ id: '', text: 'Choisir une école' }];
      const array2 = this.schools.map((school, index) => {
        if (this.roleService.getRole('ROLE_RESPONSIBLE')) {
          return {
            id: school.id,
            text: school.name,
            selected: (this.authService.getUser().School.id === school.id) ? true : false
          };
        } else {
          return { id: school.id, text: school.name };
        }
      });
      this.schoolsData = array1.concat(array2);
      this.busesData = [{ id: '', text: 'Choisir un bus' }];
      // this.initBusSelect();
    });
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (this.staticFilter.date) {
      this.staticFilter.date = moment(this.staticFilter.date).format('YYYY-MM-DD');
    }
  }
  schoolChanged(e: any) {
    this.filter.schoolId = e.value;
    this.initBusSelect();
  }

  initBusSelect() {
    let params = new HttpParams({
      fromObject: {
        clientId: this.filter.clientId,
        schoolId: this.filter.schoolId
      }
    });
    this.http.get(
      '/api/bus/lookup',
      { params }
    ).subscribe((buses: any[]) => {
      // this.filter.busId = buses.length ? buses[0].id : '';
      this.buses = buses;
      const array1 = [{ id: '', text: 'Choisir un bus' }];
      const array2 = this.buses.map(function (bus, index) {
        return { id: bus.id, text: bus.name };
      });
      this.busesData = array1.concat(array2);
    });
  }
  busChanged(e: any) {
    this.filter.busId = e.value;
  }

  ngOnDestroy(): void {
    $.fn['dataTable'].ext.search.pop();
    $('table').off();
  }

  onSelectedAllChange() {
    $('[name="checkboxs[]"]').prop('checked', this.selectedAll);
    this.onCheckChange();
  }

  onCheckChange() {
    const length = $('[name="checkboxs[]"]:checked').length;
    if (length > 1) {
      this.selectedMulti = true;
    } else {
      this.selectedMulti = false;
    }
  }

  onNavigate(url) {
    this.zone.run(() => this.router.navigateByUrl(url));
  }

  onExport(id) {
    this.http.post(
      '/api/passengerManualNotif',
      { filter: this.staticFilter }
    ).subscribe((resp: any) => {
      const data = [
        [
          'École',
          'Bus',
          'Date',
          'Type',
          'Sujet',
          'Message',
          'Envoyé'
        ]
      ];
      for (let i = 0; i < resp.data.length; i++) {
        data.push([
          resp.data[i].schoolName,
          resp.data[i].Bus.name,
          resp.data[i].date,
          resp.data[i].type,
          resp.data[i].subject,
          resp.data[i].message,
          resp.data[i].isSent ? 'Oui' : 'Non'
        ]);
      }
      this.excelService.exportAsExcelFile(data, 'messages');
    });
  }

  onDelete(id) {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer cet element ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                this.delete(id);
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  onBulkDelete() {
    this.pnotify.notice({
      title: 'Confirmation',
      text: 'Voulez-vous supprimer la selection ?',
      stack: {
        firstpos1: 70, firstpos2: 10,
        modal: true,
        overlay_close: true
      },
      hide: false,
      modules: {
        Confirm: {
          confirm: true,
          buttons: [
            {
              text: 'Ok',
              addClass: 'btn btn-chico',
              click: notice => {
                $('[name="checkboxs[]"]:checked').each((i, elt: any) => {
                  this.delete($(elt).val());
                });
                notice.close();
              }
            },
            {
              text: 'Annuler',
              addClass: 'btn btn-default',
              click: (notice) => {
                notice.close();
                notice.fire('pnotify.cancel', { notice });
              }
            }
          ]
        }
      }
    });
  }

  delete(id) {
    this.http
      .delete('/api/passengerManualNotif/' + id)
      .subscribe(
        result => {
          document.getElementById('passengerManualNotif_' + id).remove();
        },
        error => {
          this.pnotify.error({
            title: 'Erreur',
            text: 'Une erreur est survenue !',
            stack: {
              firstpos1: 70, firstpos2: 10,
              modal: true,
              overlay_close: true
            },
            hide: false,
            modules: {
              Confirm: {
                confirm: true,
                buttons: [
                  {
                    text: 'Ok',
                    addClass: 'btn btn-chico',
                    click: notice => {
                      notice.close();
                    }
                  }
                ]
              }
            }
          });
        }
      );
  }

  onFilter(): void {
    this.staticFilter = JSON.parse(JSON.stringify(this.filter));
    if (this.staticFilter.date) {
      this.staticFilter.date = moment(this.staticFilter.date).format('YYYY-MM-DD');
    }
    this.datatableElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.draw();
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/passenger-manual-notif/passenger-manual-notif-datatable/passenger-manual-notif-datatable.component.ts